import {useBackend} from 'state/backend';
import useCheckboxTriggers from '../../hooks';
import {EmployeeRightsCreateBackendData} from '../../types';
import Section from '../section';
import UIContextProvider from '../uiContextProvider';

const RightsSections = () => {
    const {
        data: {uiElements},
    } = useBackend<EmployeeRightsCreateBackendData>();

    useCheckboxTriggers();

    return (
        <UIContextProvider data={uiElements}>
            <div className="grid grid-cols-2 gap-6">
                <div>
                    <Section className="mt-4" id="document_approval" />
                    <Section className="mt-4" id="documents" />
                </div>
                <div>
                    <Section className="mt-4" id="administrator" />
                    <Section id="other" />
                    <Section id="bookkeeping" />
                </div>
            </div>
        </UIContextProvider>
    );
};
export default RightsSections;
